export default "__VITE_ASSET__BvVJeQAk__"